import React from "react";
import styled from "styled-components";
import { LabelText } from "../../ui/Text";
import { SmallLineGraph } from "../../components/SmallLineGraph/SmallLineGraph";
import { DollarIcon } from "../../assets/svg/DollarIcon";
import { PerspectiveCard } from "../../components/PerspectiveCard";
import { PeopleIcon } from "../../assets/svg/PeopleIcon";
import { Learning2 } from "../../assets/svg/Learning2";
import { SettingsIcon2 } from "../../assets/svg/SettingsIcon2";
import { get } from "../../utils/get";

interface IProps {
  data?: any;
}

const Data = [
  { x: new Date(2019, 4, 17), y: 0 },
  { x: new Date(2019, 4, 18), y: 30 },
  { x: new Date(2019, 4, 19), y: 10 },
  { x: new Date(2019, 4, 20), y: 50 },
  { x: new Date(2019, 4, 21), y: 0 },
  { x: new Date(2019, 4, 22), y: 50 },
  { x: new Date(2019, 4, 23), y: 80 },
];

export const OperatingStatistics = ({ data }: IProps) => {
  const getIcon = (name) => {
    switch (true) {
      case name.indexOf("Financial") >= 0:
        return <DollarIcon />;
      case name.indexOf("Learning") >= 0:
        return <Learning2 />;
      case name.indexOf("Customer") >= 0 || name.indexOf("Consumer") >= 0:
        return <PeopleIcon isActive />;
      case name.indexOf("Processes") >= 0:
        return <SettingsIcon2 />;
      default:
        return;
    }
  };
  const PerspectiveCardData: PerspectiveCard[] = data.map((perspective) => {
    const object = {
      color: get(perspective, "score") > 3 ? "#13C997" : " #FF6666",
      icon: getIcon(get(perspective, "perspective_name")),
      title: get(perspective, "perspective_name"),
      value: get(perspective, "weighted_periodic_score", 0),
    };

    return object;
  });
  
  return (
    <StatisticsContainer>
      {/* <LabelText>Statistics</LabelText> */}
      <PerspectiveContainer>
        {PerspectiveCardData.map((card) => (
          <PerspectiveCard
            color={card.color}
            icon={card.icon}
            title={card.title}
            value={card.value}
          />
        ))}
      </PerspectiveContainer>
      {/* <SmallLineGraph Data={Data} /> */}
    </StatisticsContainer>
  );
};

const StatisticsContainer = styled.div`
  display: grid;
  grid-template-rows: auto;
  grid-column-gap: 0.5em;
  grid-row-gap: 1em;
  padding-top: 0;
`;

const PerspectiveContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-column-gap: 1em;
  grid-row-gap: 1em;
`;
